import React from 'react';
import Button from '../../lib/button/Button';
import { ProPlanChip } from '../ProPlanChip';

interface UpgradeBannerProps {
	onUpgradeClick?: () => void;
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({ onUpgradeClick }) => {
	const handleUpgrade = onUpgradeClick || (() => window.open('/pricing/plans', '_blank'));

	return (
		<div
			style={{
				backgroundColor: '#ffffff',
				border: '1px solid #e5e7eb',
				borderRadius: '16px',
				padding: '32px 24px',
				width: '100%',
				maxWidth: '480px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				textAlign: 'center',
				boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
				fontFamily: "'Outfit', 'Inter', sans-serif",
				pointerEvents: 'auto',
			}}
		>
			<ProPlanChip />

			<h2
				style={{
					fontSize: '20px',
					fontWeight: 600,
					marginTop: '16px',
					marginBottom: '8px',
					color: '#111827',
				}}
			>
				Unlock Developer Pro Features
			</h2>

			<p
				style={{
					fontSize: '13px',
					lineHeight: '1.5',
					color: '#4b5563',
					marginBottom: '24px',
					maxWidth: '400px',
				}}
			>
				Monitor cloud executions in real-time. Gain access to Lambdas logs, detailed Scheduled execution tracking, and live endpoints inspection.
			</p>

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					gap: '12px',
					width: '100%',
					maxWidth: '320px',
					marginBottom: '28px',
					textAlign: 'left',
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<i className="fa-solid fa-terminal" style={{ color: '#6366f1', width: '16px' }}></i>
					<span style={{ fontSize: '13px', color: '#374151' }}>Real-time Log Viewer</span>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<i className="fa-solid fa-clock" style={{ color: '#6366f1', width: '16px' }}></i>
					<span style={{ fontSize: '13px', color: '#374151' }}>Scheduled execution tracking</span>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<i className="fa-solid fa-bolt" style={{ color: '#6366f1', width: '16px' }}></i>
					<span style={{ fontSize: '13px', color: '#374151' }}>Live Lambda Execution</span>
				</div>
			</div>

			<Button
				variant="solid"
				color="primary"
				size="large"
				style={{
					width: '100%',
					maxWidth: '320px',
					padding: '10px 24px',
					borderRadius: '8px',
					fontSize: '14px',
					fontWeight: 600,
					cursor: 'pointer',
				}}
				onClick={handleUpgrade}
			>
				Upgrade to Pro
			</Button>
		</div>
	);
};

export default UpgradeBanner;
